import { BaseSeratoFilter } from '@/pixi/filters/BaseSeratoFilter'
import { EffectState } from '@/pixi/filters/types'

export class VHSResFilter extends BaseSeratoFilter {

  constructor (effectState: EffectState) {
    const shader = `
    #define VHSRES vec2(320.0, 240.0)
    #define RES vec2(1920.0, 1080.0)

    varying vec2 vTextureCoord;
    uniform sampler2D uSampler;

    void main(void)
    {
      vec2 vhsResRatio = VHSRES / RES;
      gl_FragColor= texture2D(uSampler, vTextureCoord * vhsResRatio);
    }`

    super(
      effectState,
      undefined,
      shader
    )
  }

  updateUniforms () {
    // no uniforms to update
  }
}
